import React from 'react';
import { AlignRight2 } from '@good/icons';

import { useRichTextEditor } from '../rich-text-editor-context';
import { MenuButton } from './menu-button';

export const AlignRightButton = () => {
  const { editor, disabled } = useRichTextEditor();

  const isDisabled = disabled || !editor.can().chain().focus().setTextAlign('right').run();
  const onClick = () => editor.chain().focus().setTextAlign('right').run();
  const variant = editor.isActive({ textAlign: 'right' }) ? 'filled' : 'transparent';

  return (
    <MenuButton onClick={onClick} disabled={isDisabled} variant={variant} aria-label='align-right'>
      <AlignRight2 />
    </MenuButton>
  );
};
